import React, { useState, useEffect } from 'react';
import $ from 'jquery'
const Select = ({ inquiredKey, setDataName, setDataPath }) => {
  const [selectedKey, setSelectedKey] = useState(Object.keys(inquiredKey)[0]);

  const handleKeyChange = (event,callback) => {
    setSelectedKey(event.target.value);
    if (callback) {
      callback()
    }
  };
  const select=()=>{
    setTimeout(()=>{
      setDataPath($('#nav select').slice(0, -2).map(function() {
        return $(this).val()}).get().join('/'));
        setDataName($('#nav select').last().val())
    },10)
  }

  const valueChange = (event) => {
    const value = event.target.value;
    setDataName(value);
  }
 
  if (Array.isArray(inquiredKey)) {
    return (
      <select onChange={valueChange}>
        {inquiredKey.map(value => (
          <option key={value} value={value}>{value}</option>
        ))}
      </select>
    );
  } else {
    const children = inquiredKey[selectedKey] || inquiredKey[Object.keys(inquiredKey)[0]];

    return (
      <>
        <select value={selectedKey}  onChange={(event) => handleKeyChange(event, select)}>
          {Object.keys(inquiredKey).map(key => (
            <option key={key} value={key}>{key}</option>
          ))}
        </select>
        <Select inquiredKey={children} setDataName={setDataName} setDataPath={setDataPath} />

      </>
    );
  }
};

const Nav = ({ fileNestingFileName, setDataPath, setDataName }) => {  // fileNestingFileName：记录共享数据嵌套目录的配置文件名称
  const [fileNesting, setFileNesting] = useState(null);  // 记录共享数据的嵌套目录
  useEffect(() => {
    fetch(fileNestingFileName)
      .then(response => response.json())
      .then(data => {
        setFileNesting(data);
      })
      .catch(error => {
        console.error("Error fetching options.json:", error);
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileNestingFileName]);

  useEffect(()=>{
    setTimeout(()=>{
      setDataPath($('#nav select').slice(0, -2).map(function() {
        return $(this).val()}).get().join('/'));
        setDataName($('#nav select').last().val())
    },10)
  })
  if (!fileNesting) {
    return <div>Loading...</div>;
  }

  return <div id='nav'><Select inquiredKey={fileNesting} setDataName={setDataName} setDataPath={setDataPath} index={0} /></div>;
};

export default Nav;
